export default __webpack_public_path__ + "static/media/GN.15e65dae.svg";